import { createGlobalStyle } from "styled-components";
import ThemeConfig from "./ThemeConfig";

const GlobalStyle = createGlobalStyle`
  * {
	box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  }

  html, body {
    margin: 0;
    padding: 0;

    width: 100vw;
    height: 100vh;
    min-height: 100%;
    min-height: -webkit-fill-available;

    font-family: 'Fira Code', monospace;
    
    color: #fff;
    background-color: ${ThemeConfig.colors.pageBackground};
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export default GlobalStyle;
